import './CorporateRProgramCard.css';

export default function CorporateRProgramCard({ icon: Icon, title, description }) {
    return (
        <div className='corporate-r-pro-card'>
            <div className='corporate-r-pro-card-img'>
                <div className='corporate-r-pro-card-icon'>
                    <Icon />
                </div>
                <div className='corporate-r-pro-card-text'>
                    <h1>{title}</h1>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
}
